module.exports = __webpack_public_path__ + "static/media/mikmak-gradient-logo-2.b9228d23.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/mikmak-gradient-logo-2.png
// module id = 51
// module chunks = 0